export default __webpack_public_path__ + "static/media/CNo.55-3.ed8a5c6a.jpg";